import { render } from "./categoryExperts.vue?vue&type=template&id=476fd37e"
import script from "./categoryExperts.vue?vue&type=script&lang=js"
export * from "./categoryExperts.vue?vue&type=script&lang=js"

import "./categoryExperts.vue?vue&type=style&index=0&id=476fd37e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__